import { motion } from "framer-motion";

const panelBg = {
  backgroundImage:
    "repeating-linear-gradient(90deg, #4a0f19 0px, #6f1424 26px, #38040c 52px, #4a0f19 78px)",
  willChange: "transform",
};

const panelTransition = { duration: 1.5, ease: [0.76, 0, 0.24, 1] };

export const IntroCurtain = ({ opening, onEnter }) => (
  <motion.div
    data-testid="intro-curtain"
    className="fixed inset-0 z-[100] cursor-pointer select-none overflow-hidden bg-ink"
    onClick={onEnter}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.4 }}
  >
    {/* Left panel */}
    <motion.div
      className="absolute inset-y-0 left-0 w-1/2 border-r border-gold/20"
      style={panelBg}
      animate={{ x: opening ? "-100%" : "0%" }}
      transition={panelTransition}
    >
      <div className="absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-black/40 to-transparent" />
    </motion.div>

    {/* Right panel */}
    <motion.div
      className="absolute inset-y-0 right-0 w-1/2 border-l border-gold/20"
      style={panelBg}
      animate={{ x: opening ? "100%" : "0%" }}
      transition={panelTransition}
    >
      <div className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-black/40 to-transparent" />
    </motion.div>

    {/* Center emblem */}
    <motion.div
      className="absolute inset-0 z-10 flex flex-col items-center justify-center px-6 text-center"
      animate={{ opacity: opening ? 0 : 1 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      {/* lightweight static gold ring */}
      <div className="pointer-events-none absolute h-[44vh] w-[44vh] rounded-full border border-gold/15" />
      <div className="pointer-events-none absolute h-[34vh] w-[34vh] rounded-full border border-gold/10" />
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: opening ? 0 : 1, y: 0 }}
        transition={{ delay: opening ? 0 : 0.4, duration: 0.9 }}
        className="mb-5 font-sans text-[0.65rem] uppercase tracking-[0.45em] text-gold md:text-xs"
      >
        Düğünümüze Davetlisiniz
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: opening ? 0 : 1, y: 0 }}
        transition={{ delay: opening ? 0 : 0.6, duration: 0.9 }}
        className="font-serif text-6xl leading-none tracking-tight text-cream md:text-8xl"
      >
        Nurhan <span className="italic text-gold">&amp;</span> Emre
      </motion.h1>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: opening ? 0 : 1 }}
        transition={{ delay: opening ? 0 : 1.2, duration: 1 }}
        className="mt-10 flex items-center gap-3"
      >
        <span className="h-px w-8 bg-gold/50" />
        <span className="animate-pulse font-sans text-[0.7rem] uppercase tracking-[0.35em] text-sand/90">
          Perdeyi aralamak için dokunun
        </span>
        <span className="h-px w-8 bg-gold/50" />
      </motion.div>
    </motion.div>
  </motion.div>
);
